function seePassword (idName) {
    const idInput = '#'+idName
    const idIcon = '#icon-'+idName
    const input = document.querySelector(idInput)
    const icon = document.querySelector(idIcon)
    const classEye = 'fa-eye-slash'
    const classEyeSlash = 'fa-eye-slash'

    if (input.getAttribute('type') == 'text') {
        input.setAttribute('type', 'password')
        icon.classList.add( classEyeSlash )
        icon.classList.remove( classEye )
    } else if (input.getAttribute('type') == 'password') {
        input.setAttribute('type', 'text')
        icon.classList.remove( classEyeSlash )
        icon.classList.add( classEye )
    }
}

export default { seePassword }
